import React, { Component } from 'react';
import './style.css'

const TitleSection=(props)=>{
    return(
        <p className='title-section'>
            {props.children}
        </p>
    )
}

export default TitleSection